import React, {useEffect, useState} from "react";
import SubsectionBlock from "../../components/section-items/SubsectionBlock/SubsectionBlock";
import SubsectionTitle from "../../components/section-items/SubsectionTitle/SubsectionTitle";
import {fetchData} from "../../helpers/fetchData";
import Match from "../Matches/Match/Match";
import SubsectionText from "../../components/section-items/SubsectionText/SubsectionText";
import {MatchesBox, MatchHistoryContainer, TournamentBox, TournamentTitle} from "./MatchHistory.styles";
import {groupBy} from "lodash";
import {formatDate} from "../../helpers/helpersFunctions";
import {MatchesInfoText} from "../Matches/Matches.styles";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";

const MatchHistory = () => {

    const [matches, setMatches] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData('matches')
            .then((res) => setMatches(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }, []);

    const renderMatches = () => {
        const items = groupItems(matches);
        return items.map((e, index) => {
            const tournamentInfo = getTournamentInfo(e.tournament);
            return (
                <TournamentBox key={e.tournament + index}>
                    <TournamentTitle>{tournamentInfo.name + ', ' + tournamentInfo.venue + ' (' + formatDate(tournamentInfo.start_date, 'short') + ' - ' + formatDate(tournamentInfo.end_date, 'short') + ')'}</TournamentTitle>
                    <MatchesBox>
                        {e.data.map((e, index) =>
                            <Match size={'normal'}
                                   key={e.date + index}
                                   date={e.date}
                                   enemyName={e.enemy_name}
                                   result={e.result}
                                   clubGoals={e.club_goals}
                                   enemyGoals={e.enemy_goals}
                                   goalsInfo={e.goals_info}
                                   round={e.round}
                                   comment={e.comment}
                            />
                        )}
                    </MatchesBox>
                </TournamentBox>);
            }
        );
    };

    const groupItems = (data) => {
        const obj = groupBy(data, el => el.tournament_info.id);
        return Object.entries(obj).map(([key, value]) => ({tournament: key, data: value}));
    };

    const getTournamentInfo = (tournamentId) => {
        const tournament = matches.filter(e => e.tournament_info.id === tournamentId)[0].tournament_info;
        return {
            name: tournament.name,
            venue: tournament.venue,
            start_date: tournament.start_date,
            end_date: tournament.end_date
        }
    };

    return (<SubsectionBlock id={'matches'}>
        <SubsectionTitle color={'#00008B'}>{'Historia rozegranych spotkań'}</SubsectionTitle>
        <SubsectionText>{'Historia spotkań przedstawia wszystkie mecze rozegrane przez naszą drużynę, pogrupowane według turniejów. Wskaż wybrany mecz aby wyświetlić szczegółowe informacje.'}</SubsectionText>
        <MatchHistoryContainer>{isFetching ? <LoadingSpinner/> : (!isFetching && matches.length) ? renderMatches() : <MatchesInfoText>{'Brak danych do wyświetlenia.'}</MatchesInfoText>}</MatchHistoryContainer>
    </SubsectionBlock>);
};

export default MatchHistory;
